export class InitializeFeatureFlagConfiguration {
  featureFlagConfiguration;
  static type = '[FeatureFlagState] Initialize Feature Flag Configuration';
  constructor(featureFlagConfiguration) {
    this.featureFlagConfiguration = featureFlagConfiguration;
  }
}
